// @flow
import { REFRESH_TOKEN_SUCCESS } from '../containers/SignIn/constants';
import { getAuthSyncChannel } from '../utils/tabSync';

const SYNC_SOURCE = {
  REMOTE: 'REMOTE',
};

interface Auth {
  token: string;
  expiresIn: number;
}

const refreshTokenSuccess = (auth: Auth) => ({
  type: REFRESH_TOKEN_SUCCESS,
  auth,
  meta: { syncSource: SYNC_SOURCE.REMOTE },
});

// Middleware to sync auth events across multiple tabs
export const authSyncMiddleware = (store: any) => {
  const syncChannel = getAuthSyncChannel();

  syncChannel.subscribe(REFRESH_TOKEN_SUCCESS, (token) => {
    store.dispatch(refreshTokenSuccess(token));
  });

  return (next: Function) => (action: Object) => {
    const result = next(action);

    if (action.type === REFRESH_TOKEN_SUCCESS && action.auth) {
      const isLocalRefresh = !action.meta; // No meta means it originated locally

      if (isLocalRefresh) {
        syncChannel.postMessage(REFRESH_TOKEN_SUCCESS, action.auth);
      }
    }

    return result;
  };
};
